import React, { useState, useEffect, Suspense, lazy } from "react"
import { Button } from "@material-ui/core"
import { Plus } from "lucide-react"

import ContactModal from "../../../components/ContactModal"
import useStyles from "../../styles"

import useContactsStore from "../../../stores/ContactsStore"
import SearchOptions from "./SearchOptions"

const ImportContactsModal = lazy(() =>
  import(/* webpackChunkName: "import-contacts-modal" */ "../../../components/ImportContactsModal"),
)

const ContactsLayout = () => {
  const classes = useStyles()
  const [openModalImport, setOpenModalImport] = useState(false)

  const [contactModalOpen, setContactModalOpen] = useState(false)

  const [selectedContactId, setSelectedContactId] = useState(null)

  const { setSearchParam, searchParam } = useContactsStore()

  // Detecta se estamos na tela de Listas de Contatos para não mostrar o botão global "Novo"
  const cUrl = window.location.pathname
  const lPaginaListasDeContatos = cUrl.startsWith("/contact-lists")

  const handleOpenImportModal = () => {
    setOpenModalImport(true)
  }

  const handleCloseModalImport = () => {
    setOpenModalImport(false)
  }

  const handleOpenContactModal = () => {
    setSelectedContactId(null)
    setContactModalOpen(true)
  }

  const handleCloseContactModal = () => {
    setSelectedContactId(null)
    setContactModalOpen(false)
  }

  return (
    <div>
      {openModalImport && (
        <Suspense fallback={null}>
          <ImportContactsModal open={openModalImport} onClose={handleCloseModalImport} />
        </Suspense>
      )}
      <ContactModal
        open={contactModalOpen}
        onClose={handleCloseContactModal}
        aria-labelledby="form-dialog-title"
        contactId={selectedContactId}
      />

      {window.innerWidth > 1250 && !lPaginaListasDeContatos && (
        <div className={classes.buttonContainer}>
          <Button
            variant="contained"
            startIcon={<Plus />}
            stylization="primary"
            className={classes.buttonNova}
            disableElevation
            onClick={handleOpenContactModal}
          >
            Novo
          </Button>

          <SearchOptions
            style={classes.search}
            setSearchParam={setSearchParam}
            searchParam={searchParam}
            handleOpenImportModal={handleOpenImportModal}
          />
        </div>
      )}
    </div>
  )
}

export default ContactsLayout
